import React from 'react';
import Popup from 'reactjs-popup';
import NewAwningForm from '../../Quote/NewOptionFields/ShadeActions/NewAwningForm';
import { useQuoteTypeNameByQuoteId } from '../../Store/entities/quotes/hooks';

type EditAwningModalProps = {
	quoteId: number;
	lineNumber: number;
	isOpen: boolean;
	onClose: () => void;
};

const EditAwningModal = ({ quoteId, lineNumber, isOpen, onClose }: EditAwningModalProps) => {
	const quoteType = useQuoteTypeNameByQuoteId(quoteId);

	if (!isOpen) return null;

	return (
		<Popup open={isOpen} onClose={onClose} className="mobile-modal p-2 m-2">
			<NewAwningForm
				quoteId={quoteId}
				quoteType={quoteType}
				editLineNumber={lineNumber}
				onCancel={onClose}
			/>
		</Popup>
	);
};

export default EditAwningModal;
